export enum IconNames {
  Accout = 'file-invoice',
  AddressBook = 'address-book',
  AddressCard = 'address-card',
  AnalyticsInsights = 'chart-pie',
  ApiDocumentation = 'plug',
  Channels = 'home',
  Circle = 'circle',
  ContactUs = 'phone-alt',
  Contracts = 'file-contract',
  CreditCards = 'credit-card',
  CustomOffers = 'tags',
  Dashboard = 'tachometer-alt',
  FeedbackBugs = 'lightbulb',
  FinancialServices = 'file-invoice-dollar',
  Forum = 'comments',
  Home = 'home',
  IntegrationEmbed = 'cube',
  IntegrationNative = 'code',
  IntegrationPartnerPage = 'display-code',
  Integrations = 'object-group',
  Invoices = 'receipt',
  KnowlegdeBase = 'book-open',
  Leads = 'users',
  LifeInsurance = 'umbrella',
  Lock = 'lock',
  Mortgage = 'house-user',
  Network = 'globe',
  PerformanceSummary = 'chart-line',
  PersonalLoans = 'hand-holding-usd',
  PlanGrowth = 'seedling',
  PlanStarter = 'rocket',
  Savings = 'piggy-bank',
  Spiner = 'spinner',
  StudentLoanRefi = 'graduation-cap',
  Users = 'user-alt',
  YieldOptimizer = 'dollar-sign',
}

export enum KitIconNames {
  ApiSolid = 'api-solid',
  AppStore = 'app-store',
  BadgeDollarSign = 'badge-dollar-sign-solid',
  BottomCardAngled = 'bottom-card-angled',
  CaretUpDown = 'caret-up-down-custom',
  CircleDot = 'circle-dot-regular',
  CompanyLogo = 'engine-logo',
  CompanyLogoFavicon = 'engine-logo-favicon',
  CompanyLogoHorizontal = 'engine-control-center-logo-horizontal',
  CompanyLogoVertical = 'engine-control-center-logo-vertical',
  FaPcPlay = 'fa-pc-play',
  FileInvoiceDollar = 'file-invoice-dollar-solid',
  FinancialOffers = 'financial-offers',
  InProgress = 'in-progress',
  MailSent = 'mail-sent',
  MenuFold = 'menu-fold',
  MenuUnfold = 'menu-unfold',
  NullStateBenchmarkReport = 'null-state-benchmark-report',
  NullStateCustomOffers = 'null-state-custom-offers',
  NullStateEmptyPage = 'null-state-empty-page',
  NullStateLockedPage = 'null-state-locked-page',
  NullStateNoData = 'null-state-no-data',
  NullStateRevenueReporting = 'null-state-revenue-reporting',
  NullStateWorkingOnPage = 'null-state-working-on-page',
  Questionnaire = 'questionnaire',
  RevenueReport = 'revenue-report',
  SealCheckSolid = 'seal-check-solid',
  Signal = 'signal-solid',
  SquareSelectedRegular = 'square-selected-regular',
  StarShield = 'star-shield',
  ToggleOff = 'toogle-off',
  ToggleOn = 'toogle-on',
  UserSearchSolid = 'user-search-solid',
}

export enum IconTypes {
  BRANDS = 'brands',
  DUOTONE = 'duotone',
  LIGHT = 'light',
  REGULAR = 'regular',
  SOLID = 'solid',
  THIN = 'thin',
}
